import Skeleton from 'react-loading-skeleton';

export default function Progress({
  percentage,
  dropShadow,
  innerShadow,
  loading,
  gradient,
}: {
  percentage: number;
  dropShadow: string;
  innerShadow: string;
  gradient: string;
  loading?: boolean;
}) {
  return (
    <div className="h-[32px] relative rounded-[100px] w-full overflow-hidden flex gap-2">
      {loading ? (
        <Skeleton
          containerClassName="h-[32px] w-full block"
          className="h-[32px] leading-[unset!important]"
          baseColor="#DCE5F3"
          highlightColor="#FFFF"
        />
      ) : (
        <>
          <div className="w-full h-full bg-[#DCE5F3] absolute shadow-[inset_0_0_4px_rgba(119,132,154,.48)]"></div>
          <div
            style={{
              background: gradient,
              width: `${percentage}%`,
              filter: `drop-shadow(${dropShadow})`,
              boxShadow: innerShadow,
            }}
            className={`h-full transition-all text-[10px] text-white font-black flex items-center justify-end duration-300 pr-1 ease-in-out relative rounded-[100px]`}
          >
            <span className={percentage <= 10 ? 'hidden' : ''}>{percentage}%</span>
          </div>
          <span
            className={
              percentage > 10 ? 'hidden' : 'text-[10px] text-black font-black z-[1] self-center '
            }
          >
            {percentage}%
          </span>
        </>
      )}
    </div>
  );
}
